import script from "./SearchQuickLinks.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchQuickLinks.vue?vue&type=script&lang=ts&setup=true"

import "./SearchQuickLinks.vue?vue&type=style&index=0&id=609f8356&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609f8356"]])

export default __exports__